<template>
	<div class="d-flex align-center description">
		<input-editor class="edit-line" v-if="edit" :key-value="keyValue" :item="dataItem" type="text"/>
		<span
				v-else
				:class="{ 'text-decoration-line-through': dataItem.type === 0 }"
		>{{ dataItem[keyValue] }}</span
		>
		<v-btn v-if="permissions['9']" class="ml-auto" @click="editItem" x-small icon :color="color">
			<v-icon v-if="!edit"> mdi-pencil</v-icon>
			<v-icon v-else> close</v-icon>
		</v-btn>
		<v-btn v-if="permissions['9'] && permissions['11']" class="ml-2" @click="remove" x-small icon color="red">
			<v-icon> mdi-delete</v-icon>
		</v-btn>
	</div>
</template>
<script>
import InputEditor from "./input/input.component";

export default {
	components: {
		InputEditor,
	},
	props: {
		dataItem: Object,
		color: String,
		keyValue: String,
		saveMarker: Boolean
	},
	data() {
		return {
			edit: false,
		};
	},
	computed: {
		permissions() {
			return this.$store.getters.permissions;
		},
	},
	methods: {
		editItem() {
			this.edit = !this.edit;
		},
		remove() {
			this.$emit('remove-item');
		}
	},
	watch: {
		saveMarker(val) {
			if (val) this.edit = false;
		}
	},
};
</script>
<style lang="scss" scoped>
@import "./editor.component";
</style>
